/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { KartePlannerCommentMonthlyAmountFragmentDoc } from './KartePlannerCommentMonthlyAmount/KartePlannerCommentMonthlyAmount.generated';
import { KarteUserListItemKarteFragmentDoc } from './KarteUserList/KarteUserListItem.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type Plan =
  /** V2021_1 エンタープライズプラン */
  | 'V2021_1Enterprise'
  /** V2021_1 プレミアムプラン */
  | 'V2021_1Premium'
  /** V2021_1 スタンダードプラン */
  | 'V2021_1Standard'
  /** V2022_1 Enterpriseプラン */
  | 'V2022_1Enterprise'
  /** V2022_1 Entryプラン */
  | 'V2022_1Entry'
  /** V2022_1 PRプラン */
  | 'V2022_1PR'
  /** V2022_1 Proプラン */
  | 'V2022_1Pro'
  /** V2022_2 管理者専用無料プラン */
  | 'V2022_2ManageOnlyFree'
  /** V2023_1 エンタープライズプラン */
  | 'V2023_1Enterprise'
  /** V2023_1 エキスパートプラン */
  | 'V2023_1Expert'
  /** V2023_1 管理者専用無料プラン */
  | 'V2023_1ManageOnlyFree'
  /** V2023_1 マスタープラン */
  | 'V2023_1Master'
  /** V2023_1 スキルフォースプラン */
  | 'V2023_1SkillForce';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type UserGender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type LoadKarteListPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadKarteListPageQuery = { viewer: { plan: Types.Plan, kartePlannerCommentMonthlyAmount:
      | { __typename: 'ManageOnlyFreePlanKartePlannerCommentMonthlyAmount' }
      | { __typename: 'V2021_1KartePlannerCommentMonthlyAmount', items: Array<{ channel: Types.Channel, usage: number, upperLimit: number | null }> }
      | { __typename: 'V2022_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit: number | null }
      | { __typename: 'V2023_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit: number | null }
     } };

export type KarteListPageKarteConnectionEdgeFragment = { cursor: string, node: { id: string, isLikelyToMatch: boolean, hasCommentsFromPlannersBelongingToSameBranch: boolean, userComment: string, numberOfPlannerComments: number, modifiedAt: TimeString, topics: Array<{ id: string, name: string }>, ownKartePlannerComment: { id: string } | null, user: { id: string, nickname: string, channel: Types.Channel, livingPrefecture: Types.Prefecture | null, birthYear: number | null, gender: Types.UserGender, numberOfMatch: number, address: { prefecture: string, city: string } | null }, diagnosis: { annualIncome: number, saving: number, monthlyInsurance: number, investment: number, partner: { birthYear: number, annualIncome: number } | null, children: Array<{ age: number, gender: Types.Gender }> } } };

export type KarteListPageKarteConnectionFragment = { pageInfo: { endCursor: string | null, hasNextPage: boolean }, edges: Array<{ cursor: string, node: { id: string, isLikelyToMatch: boolean, hasCommentsFromPlannersBelongingToSameBranch: boolean, userComment: string, numberOfPlannerComments: number, modifiedAt: TimeString, topics: Array<{ id: string, name: string }>, ownKartePlannerComment: { id: string } | null, user: { id: string, nickname: string, channel: Types.Channel, livingPrefecture: Types.Prefecture | null, birthYear: number | null, gender: Types.UserGender, numberOfMatch: number, address: { prefecture: string, city: string } | null }, diagnosis: { annualIncome: number, saving: number, monthlyInsurance: number, investment: number, partner: { birthYear: number, annualIncome: number } | null, children: Array<{ age: number, gender: Types.Gender }> } } }> };

export const KarteListPageKarteConnectionEdgeFragmentDoc = gql`
    fragment KarteListPageKarteConnectionEdge on KarteEdge {
  cursor
  node {
    ...KarteUserListItemKarte
  }
}
    ${KarteUserListItemKarteFragmentDoc}`;
export const KarteListPageKarteConnectionFragmentDoc = gql`
    fragment KarteListPageKarteConnection on KarteConnection {
  pageInfo {
    endCursor
    hasNextPage
  }
  edges {
    ...KarteListPageKarteConnectionEdge
  }
}
    ${KarteListPageKarteConnectionEdgeFragmentDoc}`;
export const LoadKarteListPageDocument = gql`
    query LoadKarteListPage {
  viewer {
    plan
    kartePlannerCommentMonthlyAmount {
      ...KartePlannerCommentMonthlyAmount
    }
  }
}
    ${KartePlannerCommentMonthlyAmountFragmentDoc}`;

/**
 * __useLoadKarteListPageQuery__
 *
 * To run a query within a Vue component, call `useLoadKarteListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadKarteListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoadKarteListPageQuery();
 */
export function useLoadKarteListPageQuery(options: VueApolloComposable.UseQueryOptions<LoadKarteListPageQuery, LoadKarteListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadKarteListPageQuery, LoadKarteListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadKarteListPageQuery, LoadKarteListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LoadKarteListPageQuery, LoadKarteListPageQueryVariables>(LoadKarteListPageDocument, {}, options);
}
export function useLoadKarteListPageLazyQuery(options: VueApolloComposable.UseQueryOptions<LoadKarteListPageQuery, LoadKarteListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadKarteListPageQuery, LoadKarteListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadKarteListPageQuery, LoadKarteListPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LoadKarteListPageQuery, LoadKarteListPageQueryVariables>(LoadKarteListPageDocument, {}, options);
}
export type LoadKarteListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoadKarteListPageQuery, LoadKarteListPageQueryVariables>;